import styled from 'styled-components'

import { Body12 } from 'components/Typography'
import theme from 'styles/theme'

export const Conditions = styled(Body12)`
  margin: ${theme.space[8]} 0 0;
  padding-top: ${theme.space[8]};
  color: ${(props) => props.theme.colors.grayToDark};

  ${(props) =>
    props.isModal &&
    `
    border-top: 1px solid ${theme.colors.alabaster};
  `}

  ${(props) =>
    !props.isModal &&
    `
    text-align: center;
  `}
`

export const Times = styled.ol`
  margin: ${theme.space[10]} 0 0;
  padding: 0;
  list-style: none;

  li + li {
    margin-top: ${(props) => (props.isModal ? theme.space[4] : theme.space[7])};
  }
`

export const TimeRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  h6,
  span {
    font-family: ${(props) => props.theme.textStyles.fontPrimaryThin};
  }
`

export const Wrapper = styled.div`
  margin: 0 auto;

  ${(props) =>
    props.isModal &&
    `
    max-width: 400px;
  `};

  ${(props) =>
    !props.isModal &&
    `
    padding: ${theme.space[12]} 0;
${
  props.hideLine
    ? `  &:last-child {
  border-bottom: none;
}`
    : ``
};
    
    border-bottom: 1px solid ${theme.colors.alabaster};
  `};

  a {
    width: 100%;
  }

  a > span {
    margin-top: 5px;
  }
`
